import { render, staticRenderFns } from "./ModalCreateQuiz.vue?vue&type=template&id=e6fbf38c&"
import script from "./ModalCreateQuiz.vue?vue&type=script&lang=js&"
export * from "./ModalCreateQuiz.vue?vue&type=script&lang=js&"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&lang=css&"
import style1 from "./ModalCreateQuiz.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports